import { DateLike } from '@vestigas/utils';
import { currentLocale } from '~/utils';

const locale = currentLocale();

/**
 * Formats a date for use in a chart tooltip.
 * @param date - The date to format.
 * @returns The formatted date.
 */
export const formatDateForChartTooltip = (date: DateLike) => {
  if (!date || !(typeof date === 'string' || date instanceof Date)) {
    return date;
  }

  const formattedDate = Intl.DateTimeFormat(locale, {
    dateStyle: 'medium',
  }).format(new Date(date));

  return formattedDate;
};
